import React, { forwardRef } from 'react';
interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({
  className,
  label,
  ...props
}, ref) => {
  return <div className="flex items-center" data-id="element-181">
        <input type="checkbox" className="h-4 w-4 rounded border-border text-brand-600 focus:ring-brand-500" ref={ref} {...props} data-id="element-182" />
        {label && <label htmlFor={props.id} className="ml-2 block text-sm text-text-primary" data-id="element-183">
            {label}
          </label>}
      </div>;
});
Checkbox.displayName = 'Checkbox';